import * as viMessages from "devextreme/localization/messages/vi.json";
import * as enMessages from "devextreme/localization/messages/en.json";
import * as jaMessages from "devextreme/localization/messages/ja.json";
import { locale, loadMessages } from "devextreme/localization";
import { getDictionaryScreen } from "../common";

export default async function UsingIntl(code) {
  const language = localStorage.getItem("locale");
  locale(language);

  let itemCodeReplace = "";
  const itemCode = localStorage.getItem("NavigationItemCode");
  // replace /r and /n with space
  if (!code) {
    itemCodeReplace = itemCode.replace(/\r?\n/g, "");
  }

  const dictionary = await getDictionaryScreen(code ? code : itemCodeReplace);

  loadMessages(dictionary); // lấy dữ liệu từ dictionary
  loadMessages(viMessages);
  loadMessages(enMessages);
  loadMessages(jaMessages);
  // return { formatMessage };
}
